<template>
  <div class="game-page-container" ref="gameContainer">
    <!-- Top Bar (only when not fullscreen and not expanded) -->
    <!-- <div v-if="!isSimulatedFullScreen && !isFullExpanded" class="top-bar">
      <div class="top-bar-left">
        <button @click="goBack" class="back-button">
          <img src="/static/image/wrong.png" alt="关闭" class="button-icon">
        </button>
        <button @click="reloadIframe" class="refresh-button">
          <img src="/static/image/refresh.png" alt="刷新" class="button-icon">
        </button>
      </div>
      <span class="page-title">{{ gameTitle }}</span>
      <div class="top-bar-right"> -->
        <!-- <span class="balance-display">
          <span class="coin-icon">💰</span>
          0.00
        </span> -->
        <!-- <button @click="toggleFullExpand" class="fullscreen-nav-button">
          <img src="/static/image/full.png" alt="全屏" class="button-icon">
        </button>
      </div>
    </div> -->
    <!-- Iframe Container -->
    <div 
      class="iframe-container" 
      ref="iframeContainer"
      :key="iframeContainerKey"
      :class="{ 
        'scaled-to-fit': isScaledToFit
      }">
      <iframe 
        v-if="url" 
        class="game-iframe" 
        ref="iframe" 
        :src="url" 
        scrolling="no" 
        frameborder="0" 
        id="iframe">
      </iframe>
    </div>
    
    <!-- Floating Exit Fullscreen Button (only when fullscreen) -->
    <!-- <button v-if="isSimulatedFullScreen" @click="exitSimulatedFullScreen" class="exit-fullscreen-button"> -->
      <!-- &#x2716;  -->
      <!-- Using a simple 'X' symbol -->
    <!-- </button> -->
    
    <!-- Floating Scale Toggle Button (only when fullscreen) -->
    <!-- <button v-if="isSimulatedFullScreen" @click="toggleScaleToFit" class="scale-fullscreen-button" :class="{ 'active': isScaledToFit }">
      <span class="scale-icon">&#x1F50D;</span>
    </button> -->
    
    <!-- Draggable Expand Button -->
    <div 
      ref="expandButtonWrapper"
      class="expand-button-wrapper"
      :style="expandButtonStyle"
      @touchstart="startDrag" 
      @touchmove="onDrag" 
      @touchend="endDrag"
      @mousedown="startDrag"
      @click="goHome">
      <button 
        ref="expandButton"
        class="expand-button">
        <!-- 首页图标和文字 -->
        <div class="home-button-content">
          <img src="/static/image/home.png" alt="首页" class="button-icon">
          <span class="button-text">首页</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      gameId: null,
      isSimulatedFullScreen: false, // Tracks simulated fullscreen state
      gameTitle: '', // Initialize title, fetch from route query
      expandedNoticeId: null, // Added for expanded notice tracking
      noticeListInfo: {}, 
      page: 1,
      loading: false, 
      iframeContainerKey: 0, // Added key for iframe container
      isScaledToFit: false, // Track whether content is scaled to fit screen
      currentScale: 1, // Current scale factor
      scaleTimeout: null, // For debouncing scale calculations
      isDragging: false, // Track if expand button is being dragged
      dragStart: null, // Track when drag started
      dragMoved: false, // Track if actual movement occurred during drag
      expandButtonPosition: { // Default position for expand button
        x: null,
        y: null
      },
      dragOffset: { // Offset for dragging
        x: 0,
        y: 0
      },
      resizeTimeout: null, // For resize events
      longPressTimeout: null, // For detecting long press
      devicePixelRatio: window.devicePixelRatio || 1 // Get device pixel ratio for better accuracy
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    // Set title from route query if available
    if (query.name) {
      this.gameTitle = decodeURIComponent(query.name); // Decode URI component if needed
    }
    // 打开代理
    console.log(query)
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
     that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.gameId) {
      this.gameId = query.gameId;
      that.goGamePage(query.gameId, query.code);
    }
    
    // Load saved expand button position if available
    const savedPosition = localStorage.getItem('expandButtonPosition');
    if (savedPosition) {
      try {
        this.expandButtonPosition = JSON.parse(savedPosition);
      } catch (e) {
        console.error('Failed to parse saved button position', e);
      }
    }
  },
  mounted() {
    this.updateIframeHeight(); // Initial height calculation
    
    // 监听resize事件
    window.addEventListener('resize', this.handleResizeThrottled);
    
    // 监听方向变化事件
    window.addEventListener('orientationchange', this.handleOrientationChange);

    // 使用visualViewport API如果可用
    if ('visualViewport' in window) {
      window.visualViewport.addEventListener('resize', this.handleResizeThrottled);
    }
    
    // 添加鼠标事件处理
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.endDrag);
    
    // 设置初始按钮位置
    this.$nextTick(() => {
      if (!this.expandButtonPosition.x || !this.expandButtonPosition.y) {
        const button = this.$refs.expandButtonWrapper;
        if (button) {
          // 默认位置在右下角
          this.expandButtonPosition = {
            x: window.innerWidth - button.offsetWidth - 20,
            y: window.innerHeight - button.offsetHeight - 80
          };
        }
      }
      
      // 首次加载强制重新计算尺寸
      setTimeout(() => {
        this.updateIframeHeight();
        // if (this.isScaledToFit) {
        //   this.recalculateScale();
        // }
      }, 500);
    });
  },
  beforeDestroy() {
    // 移除所有事件监听器
    window.removeEventListener('resize', this.handleResizeThrottled);
    window.removeEventListener('orientationchange', this.handleOrientationChange);
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.endDrag);

    if ('visualViewport' in window) {
      window.visualViewport.removeEventListener('resize', this.handleResizeThrottled);
    }
    
    // 清除所有计时器
    if (this.longPressTimeout) {
      clearTimeout(this.longPressTimeout);
    }
    
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    
    if (this.scaleTimeout) {
      clearTimeout(this.scaleTimeout);
    }
    
    if (this.gameId) {
      console.log(`Exiting game, attempting to transfer funds back from platform ID: ${this.gameId}`);
      this.$apiFun.post('/api/gameTransfer', {
        game_platform_id: this.gameId,
        currency: 'CNY',
        type: 2
      }).then(res => {
        if (res.code === 200) {
          console.log('Funds transfer back successful or no funds to transfer.', res.message);
        } else {
          console.error('Funds transfer back failed:', res.message);
        }
      }).catch(err => {
        console.error('Error calling gameTransfer API:', err);
      });
    }
  },
  computed: {
    expandButtonStyle() {
      return {
        left: this.expandButtonPosition.x + 'px',
        top: this.expandButtonPosition.y + 'px'
      };
    }
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(gameId, code) {
      let that = this;

      that.$apiFun
        .post('/api/getGameUrl', { id: gameId, game_code: code })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$toast.fail(res.message); // Assuming Vant Toast is globally registered
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(res => {});
    },
    goBack() {
      // 尝试通过路由返回
      try {
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          // 如果没有历史记录，则返回到首页或指定页面
          this.$router.push('/');
        }
      } catch (e) {
        console.error('返回操作失败:', e);
        // 发生错误时的备用方案
        this.$router.push('/');
      }
      
      console.log('执行返回操作');
    },
    // 新增 goHome 方法
    goHome() {
      // 跳转到首页
      this.$router.push('/');
    },
    // Button drag handlers
    startDrag(event) {
      // 清除之前的长按计时器
      if (this.longPressTimeout) {
        clearTimeout(this.longPressTimeout);
      }
      
      // 记录开始时间和位置
      this.dragStart = new Date().getTime();
      
      // 重置拖动状态
      this.dragMoved = false;
      this.isDragging = false;
      
      // Get event coordinates (handle both mouse and touch)
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const clientY = event.touches ? event.touches[0].clientY : event.clientY;
      
      // Calculate offset from button position
      this.dragOffset = {
        x: clientX - this.expandButtonPosition.x,
        y: clientY - this.expandButtonPosition.y
      };
      
      // 阻止其他事件
      event.preventDefault();
    },
    onDrag(event) {
      // 如果没有开始拖动或没有事件，直接返回
      if (!this.dragStart || !event) return;
      
      // 获取当前坐标
      const clientX = event.touches ? event.touches[0].clientX : event.clientX;
      const clientY = event.touches ? event.touches[0].clientY : event.clientY;
      
      // 计算移动距离
      const initialX = this.expandButtonPosition.x + this.dragOffset.x;
      const initialY = this.expandButtonPosition.y + this.dragOffset.y;
      
      const moveDistance = Math.sqrt(
        Math.pow(clientX - initialX, 2) + 
        Math.pow(clientY - initialY, 2)
      );
      
      // 如果移动超过5px，设置为拖动模式
      if (moveDistance > 5) {
        this.dragMoved = true;
        this.isDragging = true;
        
        // 计算新位置
        const button = this.$refs.expandButtonWrapper;
        const buttonWidth = button.offsetWidth;
        const buttonHeight = button.offsetHeight;
        
        // 计算新位置，限制在视口范围内
        let newX = clientX - this.dragOffset.x;
        let newY = clientY - this.dragOffset.y;
        
        // 保持按钮在视口范围内
        newX = Math.max(0, Math.min(window.innerWidth - buttonWidth, newX));
        newY = Math.max(0, Math.min(window.innerHeight - buttonHeight, newY));
        
        // 更新位置
        this.expandButtonPosition = { x: newX, y: newY };
        
        // 防止拖动时页面滚动
        event.preventDefault();
      }
    },
    endDrag(event) {
      // 如果有长按计时器，清除它
      if (this.longPressTimeout) {
        clearTimeout(this.longPressTimeout);
        this.longPressTimeout = null;
      }
      
      // 如果没有移动过，判定为点击
      if (!this.dragMoved && this.dragStart) {
        // 执行按钮点击功能，改为回首页
        this.goHome();
      }
      
      // 如果是拖动结束，保存位置
      if (this.isDragging) {
        // 保存按钮位置
        localStorage.setItem('expandButtonPosition', JSON.stringify(this.expandButtonPosition));
      }
      
      // 重置所有状态
      this.dragStart = null;
      this.dragMoved = false;
      this.isDragging = false;
    },
    updateIframeHeight() {
      const iframeContainer = this.$refs.iframeContainer;
      if (!iframeContainer) return;

      // 获取窗口可用高度 - 兼容处理
      let viewportHeight;
      if ('visualViewport' in window) {
        viewportHeight = window.visualViewport.height;
      } else {
        // 回退方案，使用innerHeight并考虑可能的UI区域
        viewportHeight = window.innerHeight;
      }
      
      // 获取窗口宽度
      let viewportWidth = window.innerWidth;
      
      // 检测iOS版本
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const iOSVersion = isIOS ? (navigator.userAgent.match(/OS (\d+)_/i) || [])[1] : 0;
      const isOldiOS = isIOS && iOSVersion && parseInt(iOSVersion) <= 7;
      
      // iOS 7特殊处理
      if (isOldiOS) {
        console.log("检测到iOS 7，应用特殊布局处理");
        // 重新计算高度，解决顶部空白问题
        viewportHeight = document.documentElement.clientHeight || document.body.clientHeight || window.outerHeight || window.innerHeight;
        
        // 强制设置游戏容器样式
        if (this.$refs.gameContainer) {
          this.$refs.gameContainer.style.height = `${viewportHeight}px`;
          this.$refs.gameContainer.style.position = 'absolute';
          this.$refs.gameContainer.style.top = '0';
          this.$refs.gameContainer.style.left = '0';
        }
        
        // 特殊处理：调整iframe容器位置，消除顶部空白
        if (iframeContainer) {
          iframeContainer.style.position = 'absolute';
          iframeContainer.style.top = '0';
          iframeContainer.style.left = '0';
          iframeContainer.style.margin = '0';
          iframeContainer.style.padding = '0';
        }
      }
      
      // 使用一个比例因子，可以根据设备调整
      const deviceFactor = Math.min(2, window.devicePixelRatio || 1);
      const safetyMargin = isOldiOS ? 0 : (5 * deviceFactor); // 旧iOS不需要额外边距
      
      // 考虑不同设备高度差异，动态计算调整高度
      const adjustedHeight = viewportHeight;
      
      // 设置容器样式
      iframeContainer.style.width = `${viewportWidth}px`;
      iframeContainer.style.height = `${adjustedHeight}px`;
      
      // 如果显示区域非常小，可能需要缩放处理
      // if (viewportHeight < 400) {
      //   // 对于很小的屏幕，启用自动缩放
      //   this.isScaledToFit = true;
      //   this.$nextTick(() => {
      //     this.recalculateScale();
      //   });
      // }
      
      // 基本样式设置
      iframeContainer.style.overflow = 'visible';
      iframeContainer.style.display = 'flex';
      iframeContainer.style.justifyContent = 'center'; // 水平居中
      iframeContainer.style.alignItems = 'center'; // 垂直居中
      
      // 设置iframe样式
      if (this.$refs.iframe) {
        this.$refs.iframe.style.width = '100%';
        this.$refs.iframe.style.height = '100%';
        this.$refs.iframe.style.maxHeight = `${adjustedHeight}px`;
        this.$refs.iframe.style.objectFit = 'contain'; // 保持比例并完全显示
        this.$refs.iframe.style.margin = '0 auto';
        this.$refs.iframe.style.display = 'block';
        
        // 确保内容从视口顶部开始显示
        iframeContainer.style.alignItems = 'flex-start';
        
        console.log(`设置游戏区域: ${viewportWidth}x${adjustedHeight}, 设备像素比: ${deviceFactor}`);
      }
    },
    toggleScaleToFit() {
      console.log("Toggle scale to fit called!");
      this.isScaledToFit = !this.isScaledToFit;
      this.$nextTick(() => {
        if (this.isScaledToFit) {
          this.recalculateScale();
        } else {
          // Reset to default scale
          const iframeContainer = this.$refs.iframeContainer;
          if (iframeContainer) {
            iframeContainer.style.transform = 'scale(1)';
            this.currentScale = 1;
          }
        }
      });
      console.log(`Screen scaling ${this.isScaledToFit ? 'enabled' : 'disabled'}`);
    },
    recalculateScale() {
      console.log("重新计算界面缩放比例...");
      if (!this.isScaledToFit) return;
      
      // 清除现有计时器
      if (this.scaleTimeout) {
        clearTimeout(this.scaleTimeout);
      }
      
      // 设置小延迟确保DOM已更新
      this.scaleTimeout = setTimeout(() => {
        const iframe = this.$refs.iframe;
        const container = this.$refs.iframeContainer;
        
        if (!iframe || !container) {
          console.log("缺少iframe或容器元素");
          return;
        }
        
        console.log("获取元素尺寸计算缩放比例...");
        
        // 给内容加载一些时间
        setTimeout(() => {
          try {
            // 获取容器尺寸
            const containerWidth = container.clientWidth;
            const containerHeight = container.clientHeight;
            
            console.log(`容器尺寸: ${containerWidth}x${containerHeight}`);
            
            // 检测设备类型和方向
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            const isLandscape = window.innerWidth > window.innerHeight;
            
            // 针对不同设备和方向设置不同的缩放策略
            if (iframe) {
              // 确保内容完全可见
              iframe.style.width = '100%';
              iframe.style.height = '100%';
              iframe.style.maxHeight = '100%';
              
              // 对于旧设备可能需要特殊处理
              if (isMobile) {
                if (isLandscape) {
                  // 横屏模式 - 优先保证宽度
                  iframe.style.width = '100%';
                  iframe.style.height = 'auto';
                  container.style.alignItems = 'center';
                } else {
                  // 竖屏模式 - 优先保证高度
                  iframe.style.height = '100%';
                  iframe.style.width = 'auto';
                  container.style.justifyContent = 'center';
                }
              }
              
              // 总是确保居中
              iframe.style.margin = '0 auto';
              iframe.style.display = 'block';
              
              console.log(`应用优化缩放模式: ${isMobile ? '移动设备' : '桌面设备'}, ${isLandscape ? '横屏' : '竖屏'}`);
            }
          } catch (err) {
            console.error("应用缩放时出错:", err);
          }
        }, 300);
      }, 100);
    },
    // Throttle resize handler to avoid performance issues
    handleResizeThrottled() {
      if (!this.resizeTimeout) {
        this.resizeTimeout = setTimeout(() => {
          this.resizeTimeout = null;
          this.updateIframeHeight();
        }, 100); // Throttle to 100ms
      }
    },
    reloadIframe() {
      // 保存当前状态
      const wasScaled = this.isScaledToFit;
      const currentScale = this.currentScale;
      
      // 记录iframe的滚动位置（如果需要）
      let scrollPos = { top: 0, left: 0 };
      try {
        if (this.$refs.iframe && this.$refs.iframe.contentWindow) {
          scrollPos = {
            top: this.$refs.iframe.contentWindow.scrollY || 0,
            left: this.$refs.iframe.contentWindow.scrollX || 0
          };
        }
      } catch (e) {
        console.log("无法获取iframe滚动位置");
      }
      
      // 开始重新加载
      console.log(`重新加载iframe，当前状态：缩放=${wasScaled}，比例=${currentScale}`);
      
      // 重新加载iframe内容
      if (this.$refs.iframe) {
        const currentSrc = this.$refs.iframe.src;
        this.$refs.iframe.src = 'about:blank'; // 先清空
        
        setTimeout(() => {
          this.$refs.iframe.src = currentSrc; // 然后设置回原始URL
          
          // 重新加载后恢复状态
          this.$nextTick(() => {
            // 等待iframe加载完成
            this.$refs.iframe.onload = () => {
              // 恢复滚动位置
              try {
                if (this.$refs.iframe && this.$refs.iframe.contentWindow) {
                  this.$refs.iframe.contentWindow.scrollTo(scrollPos.left, scrollPos.top);
                }
              } catch (e) {
                console.log("无法恢复iframe滚动位置");
              }
              
              // 恢复缩放状态
              if (wasScaled) {
                setTimeout(() => {
                  this.isScaledToFit = true;
                  this.recalculateScale();
                }, 300);
              }
            };
          });
        }, 100);
      }
    },
    handleOrientationChange() {
      console.log("设备方向改变");
      
      // 在某些旧设备上，方向变化事件触发后需要一点时间才能获取新的窗口尺寸
      setTimeout(() => {
        // 重新计算高度
        this.updateIframeHeight();
        
        // 如果启用了缩放，则重新计算缩放
        if (this.isScaledToFit) {
          this.recalculateScale();
        }
        
        // 调整悬浮按钮位置确保其在视图内
        const button = this.$refs.expandButtonWrapper;
        if (button) {
          // 检查按钮是否超出了新的视窗边界
          if (this.expandButtonPosition.x > window.innerWidth - button.offsetWidth) {
            this.expandButtonPosition.x = window.innerWidth - button.offsetWidth - 20;
          }
          if (this.expandButtonPosition.y > window.innerHeight - button.offsetHeight) {
            this.expandButtonPosition.y = window.innerHeight - button.offsetHeight - 20;
          }
          
          // 保存新位置
          localStorage.setItem('expandButtonPosition', JSON.stringify(this.expandButtonPosition));
        }
      }, 300);
    }
  },
  watch: {
      // Watch for URL changes to ensure iframe src is updated correctly
      url(newUrl) {
          if (newUrl && this.$refs.iframe) {
              this.$refs.iframe.src = newUrl;
              
              // When URL changes, wait for content to load then recalculate if needed
              if (this.isScaledToFit) {
                // setTimeout(() => {
                //   this.recalculateScale();
                // }, 500);
              }
          }
      }
  }
};
</script>

<style lang="scss" scoped>
.game-page-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh; /* 使用vh单位可能在旧设备上有问题 */
  overflow: hidden;
  background-color: #fff;
  position: relative;
  /* 加入备用高度设置，解决旧手机上的vh问题 */
  min-height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  height: 46px; /* Fixed height for the top bar */
  background-color: #fff; /* Changed to white background */
  color: #000; /* Changed text color to black */
  flex-shrink: 0; /* Prevent bar from shrinking */
  z-index: 10;
  border-bottom: 1px solid #eee; /* Optional: add a light border for separation */
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 5px; /* Space between back and refresh buttons */
}

.back-button, .fullscreen-button, .scale-button, .action-button, .refresh-button, .fullscreen-nav-button {
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.scale-button {
  margin-right: 5px;
}

.scale-button.active, .scale-fullscreen-button.active, .expand-button.active, .button-active {
  color: #4CAF50; /* Green color when active */
}

.page-title {
  font-size: 16px;
  font-weight: bold;
  position: absolute; /* Center title */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 180px); /* Adjusted max-width: 90px reserved on each side */
}

.iframe-container {
  width: 100%;
  height: 100%; /* 高度由JS动态设置 */
  overflow: visible;
  position: relative;
  transition: transform 0.3s ease;
  /* 解决某些旧手机上的溢出问题 */
  margin: 0;
  padding: 0;
  -webkit-overflow-scrolling: touch; /* 旧iOS设备支持 */
}

.scaled-to-fit {
  transform-origin: center center;
  width: 100%;
  height: 100%;
  /* 确保旧设备上能正确应用缩放 */
  -webkit-transform-origin: center center;
}

.game-iframe {
  display: block;
  width: 100%;
  height: 100%; /* 高度由JS动态设置 */
  border: none;
  object-fit: contain;
  /* 增加更多浏览器兼容性 */
  -webkit-object-fit: contain;
  max-width: 100%;
}

/* Draggable expand button wrapper */
.expand-button-wrapper {
  position: fixed;
  z-index: 2147483646;
  width: 55px;
  height: 55px;
  transition: transform 0.2s ease;
  user-select: none;
  touch-action: none;
}

/* The actual button inside the wrapper */
.expand-button {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  touch-action: none;
  transition: background-color 0.2s ease, transform 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  padding: 0;
}

/* 新增首页按钮内容布局样式 */
.home-button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.button-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-bottom: 2px; /* 图标和文字之间的间距 */
}

.button-text {
  font-size: 12px;
  color: white;
  line-height: 1;
}

/* 图标容器 */
.fs-icon-container {
  position: relative;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shrink-icon, .expand-icon {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 角落线段基础样式 */
.corner {
  position: absolute;
  border-color: white;
  border-style: solid;
  border-width: 0;
  width: 5px;
  height: 5px;
}

/* 全屏图标 - 四个角线段向外 */
.expand-icon .top-left {
  top: 0;
  left: 0;
  border-top-width: 1.5px;
  border-left-width: 1.5px;
}

.expand-icon .top-right {
  top: 0;
  right: 0;
  border-top-width: 1.5px;
  border-right-width: 1.5px;
}

.expand-icon .bottom-left {
  bottom: 0;
  left: 0;
  border-bottom-width: 1.5px;
  border-left-width: 1.5px;
}

.expand-icon .bottom-right {
  bottom: 0;
  right: 0;
  border-bottom-width: 1.5px;
  border-right-width: 1.5px;
}

/* 退出全屏图标 - 四个角线段向内 */
.shrink-icon .top-left {
  top: 3px;
  left: 3px;
  border-top-width: 1.5px;
  border-left-width: 1.5px;
}

.shrink-icon .top-right {
  top: 3px;
  right: 3px;
  border-top-width: 1.5px;
  border-right-width: 1.5px;
}

.shrink-icon .bottom-left {
  bottom: 3px;
  left: 3px;
  border-bottom-width: 1.5px;
  border-left-width: 1.5px;
}

.shrink-icon .bottom-right {
  bottom: 3px;
  right: 3px;
  border-bottom-width: 1.5px;
  border-right-width: 1.5px;
}

/* Style for the floating exit fullscreen button */
.exit-fullscreen-button {
  position: fixed; /* Float over everything */
  top: 15px;       /* Position from top */
  right: 15px;      /* Position from right */
  z-index: 2147483647; /* Ensure it's on top (max z-index) */
  width: 40px;      /* Increased button size */
  height: 40px;     /* Increased button size */
  padding: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  color: white;
  border: none;
  border-radius: 50%; /* Make it circular */
  cursor: pointer;
  font-size: 18px;     /* Icon size */
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.scale-fullscreen-button {
  position: fixed; /* Float over everything */
  top: 15px;       /* Position from top */
  right: 65px;      /* Position from right, leave space for exit button */
  z-index: 2147483647; /* Ensure it's on top (max z-index) */
  width: 40px;      /* Increased button size */
  height: 40px;     /* Increased button size */
  padding: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  color: white;
  border: none;
  border-radius: 50%; /* Make it circular */
  cursor: pointer;
  font-size: 18px;     /* Icon size */
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.exit-fullscreen-button:hover, .scale-fullscreen-button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.exit-fullscreen-button:active, .scale-fullscreen-button:active {
  transform: scale(0.95); /* Add feedback on press */
  background-color: rgba(0, 0, 0, 0.8);
}

.expand-button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.expand-button:active {
  transform: scale(0.95); /* Add feedback on press */
  background-color: rgba(0, 0, 0, 0.8);
}

/* Added styles for new right-side elements */
.top-bar-right {
  display: flex;
  align-items: center;
}

.balance-display {
  color: #000; /* Changed text color to black */
  margin-right: 10px; /* Space between balance and action button */
  display: flex;
  align-items: center;
  font-size: 14px; /* Adjusted font size for balance */
}

.coin-icon {
  margin-right: 5px;
  font-size: 18px; /* Adjusted icon size */
}
/* End of added styles */

/* Styles for the new fullscreen button in nav bar */
.fullscreen-nav-button .fs-icon-container {
  width: 20px; /* Adjust size as needed */
  height: 20px;
}

.fullscreen-nav-button .corner {
  border-color: #000; /* Icon color to black */
}
/* End of new fullscreen button styles */

/* 为 back-button 单独添加样式以确保与 refresh-button 一致 */
.back-button {
  /* 确保 X 符号与刷新按钮的循环箭头符号视觉重量一致 */
  font-size: 24px; /* 与 refresh-button 保持一致 */
  font-weight: normal; /* 确保不加粗 */
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 添加图标按钮样式 */
.back-button, .refresh-button, .fullscreen-nav-button {
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.button-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* 移除不再需要的图标样式 */
.fs-icon-container, .corner, .expand-icon, .shrink-icon {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue